import { render, staticRenderFns } from "./UnitInput.vue?vue&type=template&id=c18c89cc&scoped=true&"
import script from "./UnitInput.vue?vue&type=script&lang=ts&"
export * from "./UnitInput.vue?vue&type=script&lang=ts&"
import style0 from "./UnitInput.vue?vue&type=style&index=0&id=c18c89cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18c89cc",
  null
  
)

export default component.exports